var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-quiz-choice"},[(_vm.type === 'single')?_c('schoice',{attrs:{"task":_vm.task,"options":_vm.options,"solution":_vm.solutions[0],"maxTries":_vm.maxTries}}):_c('mchoice',{attrs:{"task":_vm.task,"options":_vm.options,"solutions":_vm.solutions,"maxTries":_vm.maxTries}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2da6301a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/quiz-choice.vue
// module id = bRiP
// module chunks = 1